import { NodeBaseModel, InputModel } from '../models';
import { ContractsIngestionRuntimeInputDto } from '../types';
import { SourceModelBase } from '../../custom_shared/models';
import { InputModelWithSource } from '../models';

export default class InputFactory {
    static createInputs(node: NodeBaseModel, inputs: ContractsIngestionRuntimeInputDto[], sources: SourceModelBase[]) {
        return inputs.map(input => InputFactory.createInput(node, input, sources));
    }

    static createInput(node: NodeBaseModel, input: ContractsIngestionRuntimeInputDto, sources: SourceModelBase[]) {
        if (input.sourceId) {
            return new InputModelWithSource(
                node,
                input,
                sources.find(s => s.id === input.sourceId)
            );
        }

        return new InputModel(node, input);
    }

    static createOrUpdateInputs(
        node: NodeBaseModel,
        existingInputs: InputModel[],
        inputs: ContractsIngestionRuntimeInputDto[],
        sources: SourceModelBase[]
    ) {
        return inputs.map(input => {
            const repeated = /^(Limit|Deduction)(Type|Value)_\d+$/.test(input.id);
            const existingInput = existingInputs.find(existing =>
                repeated && input.guid
                    ? existing.guid === input.guid && existing.id === input.id
                    : existing.id === input.id
            );
            if (existingInput) {
                existingInput.update(input);
                return existingInput;
            }
            return InputFactory.createInput(node, input, sources);
        });
    }
}
